import 'node_modules/slick-carousel/slick/slick.scss';
import 'slick-carousel';
import 'angular-slick-carousel';

export default 'slickCarousel';
